import React from 'react'
import { useParams } from 'react-router-dom'

import { Project } from 'meta/project/project'

import { useGetPhotoPointsByIds } from 'client/store/projects/hooks/photoPoints'
import { useSearchParams } from 'client/hooks/searchParams'
import Gallery from 'client/components/Gallery'
import GalleryWrapper from 'client/components/GalleryWrapper'

import { Objects } from 'utils/objects'

type RouteParams = {
  projectName: Project['name']
}

const ProjectGallery: React.FC = () => {
  const { projectName } = useParams<RouteParams>()

  const searchParams = useSearchParams<{ ids: string }>()

  if (Objects.isNil(projectName) || Objects.isNil(searchParams.ids)) {
    throw new Error(`Invalid project name "${projectName}" for ids ${searchParams.ids}`)
  }

  const ids = searchParams.ids.split(',').map(Number)
  const photoPoints = useGetPhotoPointsByIds(projectName, ids)
  const opened = !Objects.isNil(photoPoints)

  return (
    <GalleryWrapper opened={opened}>
      {opened && <Gallery galleryKey={`${projectName}-${searchParams.ids}`} photoPoints={photoPoints} />}
    </GalleryWrapper>
  )
}

export default ProjectGallery
